//Reset data
export const RESET = "USERACTIVITE_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "USERACTIVITE_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "USERACTIVITE_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "USERACTIVITE_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "USERACTIVITE_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "USERACTIVITE_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "USERACTIVITE_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "USERACTIVITE_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "USERACTIVITE_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "USERACTIVITE_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "USERACTIVITE_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "USERACTIVITE_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "USERACTIVITE_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "USERACTIVITE_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "USERACTIVITE_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "USERACTIVITE_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "USERACTIVITE_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "USERACTIVITE_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "USERACTIVITE_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "USERACTIVITE_SHOW_SET_MODAL_TYPE"